<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('manage.categories')">Categories</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Edit Category
    </h1>

    <div class="bg-white shadow sm:rounded-lg">
      <form @submit.prevent="submit">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :errors="$page.props.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Category Name" />

          <select-input v-if="categories.length > 0" v-model="form.parent_id" :errors="$page.props.errors.parent_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Parent Category">
            <option :value="null">No Parent</option>
            <option v-for="(cat, cindx) in categories" :value="cat.id" :key="cindx">{{ cat.name }}</option>
          </select-input>

          <div>
            <text-input v-model="form.sort_order" :errors="$page.props.errors.sort_order" type="number" class="pr-6 pb-8 w-full lg:w-1/2" label="Sort Order" />
          </div>

        </div>

        <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex justify-between items-center">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete</button>
          <loading-button :loading="sending" class="btn-primary" type="submit">Update Category</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import Layout from '@/Shared/Admin/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import Toggle from '@/Shared/Toggle'

export default {
  metaInfo() {
    return { title: 'Add Category' }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput
  },
  layout: Layout,
  props: {
    category: Object,
    categories: Array
  },
  data() {
    return {
      sending: false,
      form: {
        name: this.category.name,
        parent_id: this.category.parent_id,
        active: this.category.active,
        sort_order: this.category.sort_order
      },
    }
  },
  methods: {
    submit() {
      this.sending = true
      this.$inertia.put(this.route('manage.categories.update', {category: this.category.id}), this.form, {
        onFinish: () => this.sending = false
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this category "'+this.category.name+'"?')) {
        this.$inertia.delete(this.route('manage.categories.destroy', this.category.id))
      }
    },
  },
}
</script>
